module.exports = __webpack_public_path__ + "img/card_v5.7b77210.png";